<template>
  <section class="page-section">
        <div class="index-region">
          <div class="index-header">经营概况</div>
          <div class="index-body">
            <div class="block-row flex-h">
              <div class="row-title flex-v-c">
                <div class="label">昨日</div>
              </div>
              <div class="row-content flex-a-i flex-h">
                <div class="col-item">
                  <div class="label">总销售金额</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <div class="label">总订单</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <div class="label">总付款用户</div>
                  <div class="number">100</div>
                </div>
              </div>
            </div>
            <div class="block-row flex-h">
              <div class="row-title flex-v-c">
                <div class="label">当月</div>
              </div>
              <div class="row-content flex-a-i flex-h">
                <div class="col-item">
                  <div class="label">总销售金额</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <div class="label">总订单</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <div class="label">总付款用户</div>
                  <div class="number">100</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="page-section">
        <div class="index-region">
          <div class="index-header">数据概况</div>
          <div class="index-body">
            <div class="block-row flex-h">
              <div class="row-title flex-v-c">
                <div class="label">昨日</div>
              </div>
              <div class="row-content flex-a-i flex-h">
                <div class="col-item">
                  <div class="label">访问用户</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <div class="label">新增用户</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <div class="label">新增分销商</div>
                  <div class="number">100</div>
                </div>
              </div>
            </div>
            <div class="block-row flex-h">
              <div class="row-title flex-v-c">
                <div class="label">当月</div>
              </div>
              <div class="row-content flex-a-i flex-h">
                <div class="col-item">
                  <div class="label">访问用户</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <div class="label">新增用户</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <div class="label">新增分销商</div>
                  <div class="number">100</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="page-section">
        <div class="index-region">
          <div class="index-header">订单概况</div>
          <div class="index-body">
            <div class="block-row order-row flex-h">
              <!-- <div class="row-content flex-a-i flex-h">
                <div class="col-item">
                  <img src="../../assets/icon_order_send@2x.png" class="icon">
                  <div class="label">待发货</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <img src="../../assets/icon_order_receive@2x.png" class="icon">
                  <div class="label">待收货</div>
                  <div class="number">100</div>
                </div>
                <div class="col-item">
                  <img src="../../assets/icon_order_comment@2x.png" class="icon">
                  <div class="label">待评价</div>
                  <div class="number">100</div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </section>

      <section class="page-section">
        <div class="index-region">
          <div class="index-header">快捷入口</div>
          <div class="index-body">
            <div class="block-row entry-row flex-h">
              <div class="row-content flex-a-i flex-h">
                <div class="col-item flex-v-c">
                  <img
                    src="../../assets/icon_entry_goods@2x.png"
                    class="icon"
                    @click="handlePageLinkToGoodsAdd"
                  />
                  <div class="label" @click="handlePageLinkToGoodsAdd">
                    发布商品
                  </div>
                </div>
                <div class="col-item flex-v-c">
                  <img
                    src="../../assets/icon_entry_order@2x.png"
                    class="icon"
                    @click="handlePageLinkToOrderList"
                  />
                  <div class="label" @click="handlePageLinkToOrderList">
                    订单管理
                  </div>
                </div>
                <div class="col-item flex-v-c">
                  <img
                    src="../../assets/icon_entry_user@2x.png"
                    class="icon"
                    @click="handlePageLinkToUserList"
                  />
                  <div class="label" @click="handlePageLinkToUserList">
                    用户管理
                  </div>
                </div>
                <div class="col-item flex-v-c">
                  <img
                    src="../../assets/icon_entry_distribution@2x.png"
                    class="icon"
                    @click="handlePageLinkToDistributorList"
                  />
                  <div class="label" @click="handlePageLinkToDistributorList">
                    分销管理
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

<el-dialog title="提示" :visible.sync="logoutDialogShow" width="400px">
  <p>确定退出登录？</p>

  <span slot="footer" class="dialog-footer">
    <el-button size="small" @click="logoutDialogShow = false"
      >取 消</el-button
    >
    <el-button
      size="small"
      type="primary"
      @click="logoutOnline"
      :loading="logoutLoading"
      >确 定</el-button
    >
  </span>
</el-dialog>
      </section>
</template>

<script>
import { logout, updatePsd } from "@/common/api";

export default {
  name: "dashboard",
  data() {
    return {
      crmUserMobile: localStorage.getItem("crmUserMobile"), // 获取用户手机号
      logoutDialogShow: false, // 控制退出登录弹窗显隐

      logoutLoading: false, // 控制退出登录弹窗按钮loading
    };
  },
  methods: {
    /**
     * [logoutOnline description] 退出登录事件
     * @return {[type]} [description]
     */
    logoutOnline() {
      this.logoutLoading = true;
      logout()
        .then((res) => {
          if (res.code == 0) {
            this.logoutLoading = false;
            this.logoutDialogShow = false;

            localStorage.clear();

            this.$message({ message: "退出登陆成功", type: "success" });

            this.$router.push({ path: "/login" });
          } else {
            this.logoutLoading = false;
            this.logoutDialogShow = false;
            this.$message({ message: res.msg, type: "error" });
          }
        })
        .catch((error) => {
          this.logoutLoading = false;
          this.$message.error("服务器异常");
        });
    },
    handlePageLinkToGoodsAdd: function () {
      this.$router.push({ path: "/goods/manage/add" });
    },
    handlePageLinkToOrderList: function () {
      this.$router.push({ path: "/order/order/list" });
    },
    handlePageLinkToUserList: function () {
      this.$router.push({ path: "/user/user/list" });
    },
    handlePageLinkToDistributorList: function () {
      this.$router.push({ path: "/distributor/distributormanagement/list" });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/base/mixin-font";

.index-region {
  /*padding: 10px;*/

  .index-header {
    font-size: $baseFS;
    font-weight: 500;
    line-height: 20px;
  }

  .index-body {
    padding: 5px 60px;
  }
}

.block-row {
  padding: 10px 0;

  .row-title {
    width: 80px;
  }

  .row-content {
    .col-item {
      position: relative;
      width: 140px;
      min-height: 54px;
    }
  }

  .label {
    font-size: $smallFS;
    line-height: 17px;
    color: $textColor;
  }

  .number {
    margin-top: 5px;
    font-size: 24px;
    line-height: 30px;
    color: $themeColor;
  }

  &.order-row {
    .row-content {
      .col-item {
        width: 204px;
        padding-left: 64px;

        .icon {
          position: absolute;
          z-index: 1;
          top: 50%;
          left: 0;
          margin-top: -27px;
          width: 54px;
          height: 54px;
        }
      }
    }
  }

  &.entry-row {
    .row-content {
      .col-item {
        width: 204px;
        padding-left: 64px;

        .icon {
          position: absolute;
          z-index: 1;
          top: 50%;
          left: 2px;
          margin-top: -25px;
          width: 50px;
          height: 50px;
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }
        }

        .label {
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}

::v-deep .dialog-form {
  .el-form-item {
    &.el-form-item--small {
      .el-form-item__content {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
